import VisitUsSection from '../Common/VisitUsSection';
import BookVisitSection from '../Common/BookVisitSection';
import IntroSection from '../Common/IntroSection';
import TestimonialsSection from '../Common/TestimonialSection';
import BeforeAfterGallery from './BeforeAfterGallery';
import doctor from '../../assets/doctor.png';
import React, { useEffect } from 'react';
import AnimatedSection from '../Common/AnimatedSection';
import { Link } from 'react-router';

const TransformingSmiles = () => {
  return (
    <div className="w-full bg-gradient-to-b from-teal-50 to-white py-20">
      <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row items-center gap-12">
        <div className="md:w-1/2 space-y-6 opacity-0 animate-fade-in [animation-delay:200ms]">
          <div className="inline-block px-4 py-1 bg-lime-100 text-teal-700 rounded-full text-sm font-medium mb-2">
            Our Results
          </div>
          <h2 className="text-4xl font-serif text-teal-700 leading-tight">
            Proudly transforming smiles
          </h2>
          <div className="w-20 h-1 bg-lime-500"></div>
          <p className="text-gray-700 leading-relaxed text-lg">
            At Pristine Smile, we're dedicated to delivering exceptional care. Our dentists combine state-of-the-art technology with advanced training and modern techniques to create healthy, beautiful smiles every day.
          </p>
          <p className="text-gray-700 text-lg">
            <Link 
              to="/schedule-appointment" 
              className="text-teal-600 hover:text-teal-700 transition-colors duration-300 
                         border-b-2 border-lime-400 hover:border-lime-500 font-medium"
            >
              Schedule an appointment
            </Link>
            {" "}to find out how we can transform your smile, too.
          </p>
        </div>

        <div className="md:w-1/2 relative opacity-0 animate-fade-in [animation-delay:400ms]">
          <div className="relative overflow-hidden rounded-lg shadow-xl transform hover:scale-[1.02] transition-transform duration-300">
            <img
              src={doctor}
              alt="Dental staff with patient"
              className="w-full"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-teal-500/10 to-transparent" />
          </div>
          <div className="absolute -bottom-8 -left-8 w-16 h-16 border-4 border-dotted border-lime-400 rounded-full 
                          animate-spin-slow" />
          <div className="absolute -top-8 -right-8 w-12 h-12 bg-teal-400 opacity-20 rounded-full" />
        </div>
      </div>
    </div>
  );
};

const BeforeAndAfter = () => {
  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}

      <AnimatedSection id="intro" delay={200}>
        <IntroSection 
            title={"BEFORE AND AFTER DENTAL TREATMENTS"} 
            about={"Incredible results we've achieved for our patients."}/>
      </AnimatedSection>

      {/* Main Content */}
      <main className="w-full">
        <AnimatedSection id="transforming" delay={0}>
          <TransformingSmiles />
        </AnimatedSection>

        <AnimatedSection id="gallery" delay={200} className="bg-teal-50">
          <BeforeAfterGallery />
        </AnimatedSection>

        <AnimatedSection id="testimonials" delay={400}>
          <TestimonialsSection />
        </AnimatedSection>

        <AnimatedSection id="visit" delay={600} className="bg-teal-50">
          <VisitUsSection />
        </AnimatedSection>

        <AnimatedSection id="book" delay={800}>
          <BookVisitSection />
        </AnimatedSection>
      </main>
    </div>
  );
};

export default BeforeAndAfter;